var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 80,
    viewBox: "0 0 100 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_6978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 50H90V15C90 11.0218 88.4196 7.20644 85.6066 4.3934C82.7936 1.58035 78.9782 0 75 0H25C21.0218 0 17.2064 1.58035 14.3934 4.3934C11.5804 7.20644 10 11.0218 10 15V50H5C3.67392 50 2.40215 50.5268 1.46447 51.4645C0.526784 52.4021 0 53.6739 0 55V65C0 68.9782 1.58035 72.7936 4.3934 75.6066C7.20644 78.4196 11.0218 80 15 80H85C88.9782 80 92.7936 78.4196 95.6066 75.6066C98.4196 72.7936 100 68.9782 100 65V55C100 53.6739 99.4732 52.4021 98.5355 51.4645C97.5978 50.5268 96.3261 50 95 50ZM20 15C20 13.6739 20.5268 12.4021 21.4645 11.4645C22.4021 10.5268 23.6739 10 25 10H75C76.3261 10 77.5978 10.5268 78.5355 11.4645C79.4732 12.4021 80 13.6739 80 15V50H20V15ZM90 65C90 66.3261 89.4732 67.5978 88.5355 68.5355C87.5978 69.4732 86.3261 70 85 70H15C13.6739 70 12.4021 69.4732 11.4645 68.5355C10.5268 67.5978 10 66.3261 10 65V60H90V65Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_6978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.13978d3d50417415a6b07e53058647ea.svg";
export { ForwardRef as ReactComponent };